module.exports = __webpack_public_path__ + "img/proctor-require-1.7a4f2b7b.png";